import { render, staticRenderFns } from "./AdminSeasons.vue?vue&type=template&id=a12ab5c4&scoped=true&"
import script from "./AdminSeasons.vue?vue&type=script&lang=js&"
export * from "./AdminSeasons.vue?vue&type=script&lang=js&"
import style0 from "./AdminSeasons.vue?vue&type=style&index=0&id=a12ab5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12ab5c4",
  null
  
)

export default component.exports